<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="9">
            <h3>
              {{
                perfilAtual === "B"
                  ? "Listar Avaliações de Voluntárias"
                  : "Gerenciar Avaliações das Beneficiárias"
              }}
            </h3>
          </b-col>
          <b-col md="3">
            <p><b>Nome:</b> {{ usuario.nome }}</p>
            <p><b>Perfil:</b> {{ usuarioLogado.perfil }}</p>
            <p v-if="perfilAtual !== 'A'">
              <b>Estado:</b> {{ usuarioLogado.estado }}
            </p>
            <p v-if="perfilAtual !== 'A'">
              <b>Município:</b> {{ usuarioLogado.municipio }}
            </p>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row v-if="perfilAtual === 'B'">
          <b-col offset-md="9" md="3">
            <b-button
              @click="navigate('/avaliar-voluntarias/novo')"
              block
              variant="primary"
            >
              <i class="fa fa-plus"></i>
              <span>Nova Avaliação</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row v-if="perfilAtual === 'A'">
          <b-col sm="6">
            <b-form-group label="UF:">
              <b-form-select
                v-model="filtros.uf"
                :options="estados"
                class="mb-3"
              >
                <option selected :value="null">Selecione</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="Município:" :disabled="disabled_cidades">
              <b-form-select v-model="filtros.municipio" :options="cidades">
                <option selected :value="null">Selecione</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="4">
            <b-form-group>
              <b-form-group label="Avaliações realizada para a voluntária:">
                <b-form-select v-model="filtros.voluntaria" class="mb-3">
                  <option
                    v-for="item in listavoluntarias"
                    :key="item.voluntario_id"
                    :value="item.voluntario_id"
                  >
                    {{ item.nome }}
                  </option>
                  <option selected :value="null">Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group v-if="perfilAtual !== 'B'">
              <b-form-group label="Relatório de encontro com a Beneficiária:">
                <b-form-select v-model="filtros.beneficiaria" class="mb-3">
                  <option
                    v-for="item in listabeneficiarias"
                    :key="item.voluntario_id"
                    :value="item.voluntario_id"
                  >
                    {{ item.nome }}
                  </option>
                  <option selected :value="null">Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group v-if="perfilAtual !== 'B'">
              <b-form-group label="Quantas Estrelas:">
                <b-form-select v-model="filtros.estrelas" class="mb-3">
                  <option selected :value="null">Selecione</option>
                  <option selected :value="1">1 estrela</option>
                  <option selected :value="2">2 estrelas</option>
                  <option selected :value="3">3 estrelas</option>
                  <option selected :value="4">4 estrelas</option>
                  <option selected :value="5">5 estrelas</option>
                </b-form-select>
              </b-form-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-button @click="limpafiltro" block variant="cinza">
              <i class="fa fa-eraser"></i>
              <span>Limpar filtros</span>
            </b-button>
          </b-col>
          <b-col md="2">
            <b-button @click="pesquisar" block variant="primary">
              <i class="fa fa-search"></i>
              <span>Pesquisar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <span>
              <b-form-select style="width: 100px; float: right" class="mb-3" v-model="totalPorPagina" :options="totalSelectOp"></b-form-select>
              <table
                aria-rowcount="4"
                id="my-table"
                aria-busy="false"
                aria-colcount="7"
                class="
                  table
                  table-responsive-sm
                  table-bordered
                  table-striped
                  table-sm
                "
              >
                <thead>
                  <tr>
                    <th scope="col" v-if="perfilAtual !== 'B'">UF</th>
                    <th scope="col" v-if="perfilAtual !== 'B'">Município</th>
                    <th scope="col" v-if="perfilAtual !== 'B'">Beneficiária</th>
                    <th scope="col">
                      {{
                        perfilAtual !== "B"
                          ? "Avaliando a Voluntária"
                          : "Avaliações realizadas para a Voluntária"
                      }}
                    </th>
                    <th scope="col" v-if="perfilAtual === 'B'">Data e Hora</th>
                    <th scope="col">Estrelas</th>
                    <th scope="col" v-if="perfilAtual === 'A'">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="avaliacoes.data !== undefined">
                  <tr v-for="avaliacao in avaliacoes.data" :key="avaliacao.id">
                    <td v-if="perfilAtual !== 'B'">{{ avaliacao.sigla }}</td>
                    <td v-if="perfilAtual !== 'B'">{{ avaliacao.cidade }}</td>
                    <td v-if="perfilAtual !== 'B'">
                      {{ avaliacao.beneficiaria }}
                    </td>
                    <td>{{ avaliacao.voluntaria }}</td>
                    <td v-if="perfilAtual === 'B'">
                      {{ formatDate(avaliacao.data) + " " + avaliacao.hora }}
                    </td>
                    <td>
                      <star-rating
                        v-model="avaliacao.estrelas"
                        :border-width="1"
                        v-bind:star-size="10"
                        v-bind:max-rating="5"
                        :read-only="true"
                      />
                    </td>
                    <td style="width: 15%" v-if="perfilAtual === 'A'">
                      <a
                        v-if="perfilAtual === 'A'"
                        class="btn btn-sm btn-secondary action"
                        title="Editar Avaliação"
                        @click="editarCaptcha(avaliacao.id)"
                      >
                        <i class="fa fa-pencil-square-o"></i>
                      </a>

                      <a
                        v-if="perfilAtual === 'A'"
                        class="btn btn-sm btn-secondary action"
                        title="Excluir Avaliação"
                        @click="excluiravaliacao(avaliacao.id)"
                      >
                        <i class="fa fa-times"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="6">Nenhum registro de avaliações...</td>
                  </tr>
                </tbody>
              </table>
              <pagination
                v-show="avaliacoes.data !== undefined"
                :totalPorPagina="totalPorPagina"
                :resource="resource"
                :filtros="filtros"
              ></pagination>
            </span>
          </b-container>
        </b-col>
      </b-row>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/PaginationAvaliacoes'
import { eventType } from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'
import StarRating from 'vue-star-rating'

miniToastr.init()

export default {
  components: {
    StarRating,
    Pagination
  },
  created () {
    if (
      SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'B' ||
      SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'L' ||
      SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'P' ||
      SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'A'
    ) {
      this.$store.dispatch('buscarMunicipiosProgramas')
      this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
      this.getVoluntaias()
      this.perfilAtual = SessionStorage.get('tipoPerfil').replace(/['"]+/g, '')
    } else {
      this.$router.push('/')
    }
    if (
      SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'L' ||
      SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'P' ||
      SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'A'
    ) {
      this.$store.dispatch('getVoluntario')
      this.$store.dispatch('getBeneficiaria')
      this.$store.dispatch('buscarEstados3')
    }
  },
  data () {
    return {
      mainProps: { width: 250, height: 250 },
      countadorErros: 0,
      perfilAtual: '',
      tentativas: 1,
      respostaErrada: false,
      respostaCerta: false,
      modalSimular: false,
      totalPorPagina: 20,
      totalSelectOp: [
        {text: '20', value: 20},
        {text: '30', value: 30},
        {text: '50', value: 50},
        {text: '100', value: 100}
      ],
      resource: 'avaliacoes',
      disabled_cidades: true,
      listavoluntarias2: [],
      filtros: {
        filter: '',
        beneficiaria: null,
        voluntaria: null,
        uf: null,
        municipio: null,
        estrelas: null
      },
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: '',
        nome: ''
      }
    }
  },
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    },
    avaliacoes () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    listabeneficiarias () {
      return this.$store.state.usuario.ListaBeneficiaria
    },
    listavoluntarias () {
      if (this.listavoluntarias2.length > 0) { return this.listavoluntarias2 }
      return this.$store.state.usuario.ListaVoluntario
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    }
  },
  watch: {
    'usuario.perfil': function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome
      this.usuarioLogado.nome = this.usuario.nome
    },
    'usuario.dados_pessoais': function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    },
    'filtros.uf': function () {
      if (this.filtros.uf !== null) {
        this.$store.dispatch('buscarCidadesPorEstado2', this.filtros.uf)
        this.$store.dispatch('getBeneficiaria2', this.filtros.uf)
        this.$store.dispatch('getVoluntario2', this.filtros.uf)
        this.disabled_cidades = false
      } else {
        this.disabled_cidades = true
        this.filtros.municipio = null
      }
      this.setarFiltros(this.filtros)
    },
    'filtros.municipio': function () {
      this.$store.dispatch('getBeneficiaria3', this.filtros.municipio)
      this.$store.dispatch('getVoluntario3', this.filtros.municipio)
    }
  },
  methods: {
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    pesquisar () {
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    },
    limpafiltro () {
      this.filtros = {
        filter: '',
        beneficiaria: null,
        voluntaria: null,
        uf: null,
        municipio: null,
        estrelas: null
      }
      this.pesquisar()
    },
    editarCaptcha (id) {
      this.$router.push('/avaliar-voluntarias/editar/' + id)
    },
    getVoluntaias () {
      if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'B') {
        Vue.http.get('api/avaliacoes-voluntarias').then((response) => {
          this.listavoluntarias2 = response.body.data[0]
        })
      }
    },
    excluiravaliacao (id) {
      this.$bvModal
        .msgBoxConfirm('Deseja realmente excluir essa avaliação?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            Vue.http
              .delete('api/avaliacoes/' + id)
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearch2', {
                    resource: this.resource,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
              .catch((erro) => {
                if (!erro.body.success) {
                  miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
                  miniToastr.error(erro.body.msg, 'Alerta!', 7000)
                  this.$store.dispatch('getRegistrosSearch2', {
                    resource: this.resource,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
          }
        })
        .catch((erro) => {
          console.log(erro)
        })
    },
    formatDate (dataInput) {
      let data = new Date(dataInput)
      let dataFormatada = data.toLocaleDateString('pt-BR', { timeZone: 'UTC' })
      return dataFormatada
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
.action {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/beneficiaria/AvaliarEncontro.vue